<script>
export default {
  name: 'TwImg',
  props: {
    src: {
      type: String,
      default: "/img/cover-image-placeholder.jpg",
    },
    fallback: {
      type: String,
      default: "/img/cover-image-placeholder.jpg", // Default fallback image
    },
    alt: {
      type: String,
      default: "Image",
    },
    imgStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['error'],
  data() {
    return {
      CurrentSrc: null,
    };
  },
  beforeMount () {
    if(this.src) {
      this.CurrentSrc = this.src;
    } else {
      this.CurrentSrc = this.fallback;
    }
  },
  methods: {
    handleError() {
      if (this.CurrentSrc !== this.fallback) {
        this.CurrentSrc = this.fallback;
        this.$emit("error", this.src); // Emit event for logging
      }
    },
  },
};
</script>

<template>
  <img
    :src="CurrentSrc"
    :alt="alt"
    :style="imgStyle"
    @error="handleError"
  >
</template>

<style scoped>

</style>
